import { Component, computed, input, output } from '@angular/core';
import { CommonTemplate } from '../../../../api/api-types/document.api';
import { LvrHtmlEditor } from '../../../../core/components/html-editor/html-editor';
import { CarouselElement, NavCarousel } from '../../../../core/components/nav-carousel/nav-carousel';
import { TranslocoPipe } from '@jsverse/transloco';
import { LvrButton } from '../../../../core/components/lvr-button/lvr-button';
import { toTemplateSlug } from '../../../../shared/helpers/to-template-slug.func';

@Component({
	selector: 'lvr-common-template-editor',
	imports: [LvrHtmlEditor, NavCarousel, TranslocoPipe, LvrButton],
	templateUrl: './common-template-editor.html',
	styleUrl: './common-template-editor.scss',
})
export class LvrCommonTemplateEditor {
	public readonly template = input.required<CommonTemplate>();
	public readonly templates = input.required<CommonTemplate[]>();
	public readonly backLink = input.required<string>();
	public readonly isPrinting = input<boolean>(false);
	public readonly isProcessing = input<boolean>(false);

	public readonly navigateToTemplate = output<string>();
	public readonly printClicked = output<void>();
	public readonly exportClicked = output<void>();
	public readonly htmlChanged = output<string>();

	public readonly templateName = computed(() => `${this.template().name.split('.')[0]}`);
	public readonly templateHtmlContent = computed(() => this.template().htmlContent);

	public readonly carouselElements = computed(() =>
		(this.templates() || []).map((t) => ({
			id: toTemplateSlug(t.name),
			label: t.name.split('.')[0],
		})),
	);

	public readonly currentIndex = computed(() => {
		const id = toTemplateSlug(this.template().name);
		return this.carouselElements().findIndex((e) => e.id === id);
	});

	public onNavigate(event: { index: number; element: CarouselElement }) {
		this.navigateToTemplate.emit(event.element.id);
	}

	public print() {
		this.printClicked.emit();
	}

	public export() {
		this.exportClicked.emit();
	}

	public onDocChange(html: string) {
		this.htmlChanged.emit(html);
	}
}
